export default {
    domains: [],
    domain:{},
};